// import Vue from 'vue'

export default {
    name : 'scrollto',
    init() {
        this.run();
        this.initBackToTop();
    },
    run ()
    {
        const elements = document.querySelectorAll('.scroll-to');

        if (elements && elements.length) {
            elements.forEach((btn) => {
                btn.addEventListener("click", function(event){
                    event.preventDefault();
                    const element = document.querySelector("#"+this.dataset.target);
                    element.scrollIntoView({ behavior: 'smooth', block: 'start'});
                });
            });
        }
    },
    initBackToTop()
    {
      window.addEventListener('scroll', function() {
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        // const scrollPosition = $(window).scrollTop();
        const scrollPosition = window.scrollY;

        if (scrollPosition >= window.outerHeight) {
          document.getElementById("btt").classList.add("active");
        } else {
          document.getElementById("btt").classList.remove("active");
        }
      });
    }

}